import React, {useContext, useEffect, useImperativeHandle, useRef, useState} from 'react'
import {Modal, Form, Row, Col, Input, Button, Select, InputNumber, Table, Popconfirm} from 'antd'
import {DeleteOutlined, PlusCircleOutlined} from '@ant-design/icons'
import {withTranslation, useTranslation} from 'react-i18next'

const EditableContext = React.createContext(null)

const EditableRow = ({index, ...props}) => {
  const [form] = Form.useForm()
  return (
    <Form form={form} component={false}>
      <EditableContext.Provider value={form}>
        <tr {...props} />
      </EditableContext.Provider>
    </Form>
  )
}

const EditableCell = ({value, title, editable, children, dataIndex, record, handleSave, ...restProps}) => {
  const {t} = useTranslation()
  const inputRef = useRef(null)
  const form = useContext(EditableContext)

  useEffect(() => {
  }, [])

  const fieldTypeList = [
    {value: 'BOOLEAN', label: 'Boolean'},
    {value: 'NUMBER', label: 'Number'},
    {value: 'STRING', label: 'String'},
    {value: 'STRUCT', label: 'Struct'},
    {value: 'ARRAY', label: 'Array'},
    {value: 'DATESTRING', label: 'Date'}
  ]
  const arrayTypeList = fieldTypeList.filter(item => item.value !== 'ARRAY')

  const changeType = async () => {
    const values = await form.validateFields()
    if ((values.fieldType === 'ARRAY' && values.arrayType === 'STRUCT') || values.fieldType === 'STRUCT') {
      record.children = record.children || []
    } else {
      record.children = null
    }
    if (values.fieldType !== 'ARRAY') {
      record.arrayType = null
    }
    if (values.fieldType !== 'DATESTRING') {
      record.format = null
    }
    if (values.fieldType !== 'STRING') {
      record.length = null
    }
    save()
  }

  const save = async () => {
    try {
      const values = await form.validateFields()
      // toggleEdit();
      handleSave({...record, ...values})
    } catch (errInfo) {
      console.log('Save failed:', errInfo)
    }
  }

  let childNode = children

  if (editable) {
    if (dataIndex === 'name') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.name ? record.name : ''}>
          <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
        </Form.Item>
      )
    } else if (dataIndex === 'path') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.path ? record.path : ''}>
          <Input ref={inputRef} onPressEnter={save} onBlur={save}/>
        </Form.Item>
      )
    } else if (dataIndex === 'fieldType') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.fieldType ? record.fieldType : ''}>
          <Select
            placeholder={t(`apiManagement.selectFieldType`)}
            onSelect={() => changeType(record)}
          >
            {fieldTypeList.length > 0 ? fieldTypeList.map(item => <Select.Option key={item.value}
                                                                                 value={item.value}>{item.label}</Select.Option>) : null}
          </Select>
        </Form.Item>
      )
    } else if (dataIndex === 'arrayType') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.arrayType ? record.arrayType : null}>
          <Select
            placeholder={t(`apiManagement.selectArrayType`)}
            onSelect={() => changeType(record)}
            disabled={record.fieldType !== 'ARRAY'}
          >
            {arrayTypeList.length > 0 ? arrayTypeList.map(item => <Select.Option key={item.value}
                                                                                 value={item.value}>{item.label}</Select.Option>) : null}
          </Select>
        </Form.Item>
      )
    } else if (dataIndex === 'length') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.length ? record.length : ''}>
          <InputNumber disabled={record.fieldType !== 'STRING'} min={1} onPressEnter={save} onBlur={save}/>
        </Form.Item>
      )
    } else if (dataIndex === 'format') {
      childNode = (
        <Form.Item style={{margin: 0,}} name={dataIndex} initialValue={record.format ? record.format : ''}>
          <Input disabled={record.fieldType !== 'DATESTRING'} ref={inputRef} onPressEnter={save} onBlur={save}/>
        </Form.Item>
      )
    }
  }

  return <td {...restProps}>{childNode}</td>
}

const FieldSetModal = (props) => {
  const {fileSetVisible, handleCancel, onRef, onChange, t} = props
  useImperativeHandle(onRef, () => ({
    init,
  }))
  const [formHead] = Form.useForm()
  const formItemLayout = {
    labelCol: {span: 8},
    wrapperCol: {span: 16},
  }
  // const formItemLayout2 = {
  //   labelCol: {span: 4},
  //   wrapperCol: {span: 20},
  // }
  const fieldTypeList = [
    {value: 'BOOLEAN', label: 'Boolean'},
    {value: 'NUMBER', label: 'Number'},
    {value: 'STRING', label: 'String'},
    {value: 'STRUCT', label: 'Struct'},
    {value: 'ARRAY', label: 'Array'},
    {value: 'DATESTRING', label: 'Date'}
  ]
  const arrayTypeList = fieldTypeList.filter(item => item.value !== 'ARRAY')
  const [detail, setDetail] = useState({})
  // eslint-disable-next-line no-unused-vars
  const [count, setCount] = useState(0)
  const init = (item, changeFieldSet, editFieldLoading) => {
    let record = JSON.parse(JSON.stringify(item))
    record.children = addRowKey(record.children)
    setDetail(record)
  }
  const addRowKey = (list, level = '') => {
    if (!list) {
      return null
    }
    const newList = []
    list.forEach((item, i) => {
      const index = level ? `${level}-${i + 1}` : `${i + 1}`
      const newItem = {
        ...item,
        index: index,
        children: addRowKey(item.children, index)
      }
      newList.push(newItem)
    })
    return newList
  }

  const changeType = async (record) => {
    const values = await formHead.validateFields()
    if ((values.fieldType === 'ARRAY' && values.arrayType === 'STRUCT') || values.fieldType === 'STRUCT') {
      record.children = record.children || []
    } else {
      record.children = null
    }
    if (values.fieldType !== 'ARRAY') {
      record.arrayType = null
    }
    if (values.fieldType !== 'DATESTRING') {
      record.format = null
    }
    if (values.fieldType !== 'STRING') {
      record.length = null
    }
    setDetail({...detail, ...values})
  }

  const rowKey = (item) => {
    return item.index
  }

  const defaultColumns = [
    {
      title: t(`apiManagement.no`),
      width: '10%',
      dataIndex: 'index',
    },
    {
      title: t(`apiManagement.name`),
      dataIndex: 'name',
      width: '20%',
      editable: true,
    },
    {
      title: t(`apiManagement.path`),
      dataIndex: 'path',
      width: '10%',
      editable: true,
    },
    {
      title: t(`apiManagement.type`),
      dataIndex: 'fieldType',
      width: '10%',
      editable: true,
    },
    {
      title: t(`apiManagement.length`),
      dataIndex: 'length',
      width: '10%',
      editable: true,
    },
    {
      title: t(`apiManagement.dateFormat`),
      dataIndex: 'format',
      width: '10%',
      editable: true,
    },
    {
      title: t(`apiManagement.arrayType`),
      dataIndex: 'arrayType',
      width: '10%',
      editable: true,
    },
    {
      title: t(`general.action`),
      dataIndex: 'action',
      align: 'center',
      render: (_, record, index) =>
        detail.children.length >= 1 ? (
          <>
            {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
            {record.children ? (<a style={{marginRight: 16}}><PlusCircleOutlined onClick={() => handleAdd(record, 'childRow')}/></a>) : null}
            <Popconfirm title={t(`general.sureToDelete`)} onConfirm={() => handleDelete(record, index)}>
              {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
              <a><DeleteOutlined/></a>
            </Popconfirm>
          </>
        ) : null,
    },
  ]
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  }
  const getTreeParent = (treeList, findItem, keyword) => {
    let curItem = null
    const someItem = (list, parentItem) => {
      // eslint-disable-next-line array-callback-return
      list && list.some(item => {
        if (item[keyword] === findItem[keyword]) {
          curItem = parentItem
        } else if (item.children) {
          someItem(item.children, item)
        }
        if (curItem) {
          return true
        }
      })
    }
    someItem(treeList, null)
    return curItem
  }
  const handleDelete = (record, key) => {
    const dataSource = JSON.parse(JSON.stringify(detail))
    const parentItem = getTreeParent(dataSource.children, record, 'index')
    if (parentItem) {
      // parentItem.children.splice(key, 1)
      dataSource.children.forEach(item => {
        if (item.index === parentItem.index) {
          item.children.splice(key, 1)
        }
      })
    } else {
      dataSource.children.splice(key, 1)
    }
    setDetail({...dataSource})
  }
  const handleAdd = (item, type) => {
    const newData = {
      key: item.children.length,
      index: item.children.length + 1,
      fieldType: '',
      arrayType: '',
      format: '',
      length: '',
      name: '',
      path: '',
      children: null
    }

    item.children.push(newData)
    detail.children = addRowKey(detail.children)
    setDetail({...detail})
    setCount(item.children.length + 1)
  }
  const getObj = (arr, row) => {
    // let newData = [...detail.children];
    arr.forEach(function (item, index) {
      // if(item.key===row.key){
      if (item.index === row.index) {
        arr.splice(index, 1, {...item, ...row})
      } else if (item.children && item.children.length > 0) {
        getObj(item.children, row)
      }
    })
    return arr
  }
  const handleSave = (row) => {
    let newData = getObj(detail.children, row)
    detail.children = addRowKey(newData)
    setDetail({...detail})
  }
  const Save = async () => {
    try {
      const values = await formHead.validateFields()
      detail.children = addRowKey(detail.children)
      onChange({...detail, ...values})
      handleCancel()
    } catch (errInfo) {
      console.log('Save failed:', errInfo)
    }
  }
  const columns = defaultColumns.map((col) => {
    if (!col.editable) {
      return col
    }

    return {
      ...col,
      onCell: (record) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        changeType,
        handleSave,
      }),
    }
  })
  return (
    <>
      <Modal
        title={t(`apiManagement.fieldSet`)}
        closable={false}
        visible={fileSetVisible}
        maskClosable={false}
        destroyOnClose={true}
        width={1500}
        centered
        footer={[
          <Button key="Cancel" onClick={handleCancel}>{t(`general.cancel`)}</Button>,
          <Button key="Save" type="primary" onClick={Save}>{t(`general.save`)}</Button>,
        ]}
      >
        {
          detail.name ? (
            <>
              <Form form={formHead} name="basic" autoComplete="off"
              >
                <Row wrap={true} gutter={[10, 20]}>
                  <Col span={12}>
                    <Form.Item label={t(`apiManagement.filedName`)} name="name" {...formItemLayout} initialValue={detail.name ? detail.name : ''}>
                      <Input placeholder={`${t(`general.pleaseEnter`)} ${t(`apiManagement.filedName`)}`} allowClear/>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item style={{margin: 0,}} name="fieldType" label={t(`apiManagement.filedType`)} {...formItemLayout}
                               initialValue={detail.fieldType ? detail.fieldType : ''}>
                      <Select
                        placeholder={t(`apiManagement.selectFieldType`)}
                        onSelect={() => changeType(detail)}
                      >
                        {fieldTypeList.length > 0 ? fieldTypeList.map(item => <Select.Option key={item.value}
                                                                                             value={item.value}>{item.label}</Select.Option>) : null}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item style={{margin: 0,}} name="length" label={t(`apiManagement.length`)} {...formItemLayout}
                               initialValue={detail.length ? detail.length : ''}>
                      <InputNumber disabled={detail.fieldType !== 'STRING'} min={1}/>
                    </Form.Item>
                  </Col>
                  {
                    detail.fieldType === 'DATESTRING' ? (
                      <Col span={12}>
                        <Form.Item style={{margin: 0,}} name="format" label={t(`apiManagement.dateFormat`)} {...formItemLayout}
                                   initialValue={detail.format ? detail.format : ''}>
                          <Input/>
                        </Form.Item>
                      </Col>
                    ) : null
                  }
                  {
                    detail.fieldType === 'ARRAY' ? (
                      <Col span={12}>
                        <Form.Item style={{margin: 0,}} name="arrayType" label={t(`apiManagement.arrayType`)} {...formItemLayout}
                                   initialValue={detail.arrayType ? detail.arrayType : null}>
                          <Select
                            placeholder={t(`apiManagement.selectArrayType`)}
                            onSelect={() => changeType(detail)}
                          >
                            {arrayTypeList.length > 0 ? arrayTypeList.map(item => <Select.Option key={item.value}
                                                                                                 value={item.value}>{item.label}</Select.Option>) : null}
                          </Select>
                        </Form.Item>
                      </Col>
                    ) : null
                  }
                </Row>
              </Form>
              {detail.children && detail.children.length ? (
                <div style={{marginTop: 30}}>
                  <Button onClick={() => handleAdd(detail, 'row')} type="primary"
                          style={{marginBottom: 16, marginRight: 16,}}>{t(`general.add`)}</Button>
                  <Table
                    components={components}
                    dataSource={[...detail.children]}
                    rowKey={rowKey}
                    columns={columns}
                    pagination={false}
                  />
                </div>
              ) : null}
            </>
          ) : null
        }
      </Modal>
    </>
  )
}

export default withTranslation()(FieldSetModal)
